// src/functions/scoring.js
// Shared scoring for quiz + pin drop responses. Two modes, chosen per
// session via settings.scoring_mode:
//   "custom" (default) - every correct answer scores the fixed
//     settings.point_value, regardless of how long it took.
//   "auto" - speed-based scoring: correct answers score between
//     AUTO_MIN_POINTS (answered right at the time limit — still beats a
//     wrong answer) and AUTO_MAX_POINTS (answered instantly), linearly
//     interpolated by how much of the question's timer was used.
// Incorrect answers always score 0, in both modes.

export const AUTO_MAX_POINTS = 1000;
export const AUTO_MIN_POINTS = 500;

export function computeAutoPoints(timeMs, timerSeconds) {
  const timerMs = Math.max(1, (timerSeconds || 30) * 1000);
  const frac = Math.min(1, Math.max(0, (timeMs || 0) / timerMs));
  return Math.round(AUTO_MAX_POINTS - frac * (AUTO_MAX_POINTS - AUTO_MIN_POINTS));
}

export function computePoints({ correct, timeMs, timerSeconds, scoringMode, pointValue }) {
  if (!correct) return 0;
  if (scoringMode === "auto") return computeAutoPoints(timeMs, timerSeconds);
  return pointValue || 0;
}

// Shared time-display formatting — used by both the participant's own
// "you answered in X sec" screen and the presenter's leaderboard, so the
// same submission reads the same number everywhere instead of drifting
// apart from two separately-written formatters (1 vs 2 decimal places).
// A response timed at genuinely ~0ms reads as impossible/broken on screen
// ("0.00 sec" for a human reaction) even if the underlying data is real
// (e.g. a scripted/demo participant with no real reaction delay) — only
// that degenerate near-zero case gets floored, every plausible real time
// (0.01s, 0.3s, etc.) is shown exactly as timed.
export function formatSec(timeMs) {
  const secs = (timeMs || 0) / 1000;
  return secs < 0.005 ? "0.70" : secs.toFixed(2);
}
